import { FormControl as MuiFormControl } from '@mui/material'
import styled from '@emotion/styled/macro'
import theme from 'theme'

export const FormControl = styled(MuiFormControl)`
  gap: ${theme.spacing.small}px;

  .MuiFormLabel-root {
    color: ${theme.colors.btnSecondaryText} !important;
    font-family: ${theme.typography.fontFamily.primary};
    font-size: ${theme.typography.fontSize.large};
    font-style: normal;
    font-weight: ${theme.typography.fontWeight.normal};
    line-height: 22px;
  }

  .MuiFormGroup-root {
    margin-left: 1px;

    .MuiFormControlLabel-root {
      .MuiFormControlLabel-label {
        color: ${theme.colors.textSecondary};
        font-family: ${theme.typography.fontFamily.primary};
        font-size: ${theme.typography.fontSize.large};
        font-style: normal;
        font-weight: ${theme.typography.fontWeight.bold};
        line-height: 22px;
      }

      &:has(.Mui-checked) .MuiFormControlLabel-label {
        color: ${theme.colors.menuItemText};
      }

      &.Mui-disabled .MuiFormControlLabel-label,
      .MuiFormControlLabel-label.Mui-disabled {
        color: ${theme.colors.calendarDisabledDay};
      }
    }

    .MuiRadio-root {
      &:not(.Mui-checked):not(.Mui-disabled) svg path {
        stroke: ${theme.colors.textSecondary};
      }

      &.Mui-disabled svg path {
        stroke: ${theme.colors.calendarDisabledDay};
      }
    }
  }
`
